import { LMS_TEACHER_HOMEBASE_FEATURE_FLAG } from "../../shared/featureFlags";
import { useFeatureFlag } from "../lib/FeatureFlags";

export function useLmsTeacherHomebase() {
  return useFeatureFlag(LMS_TEACHER_HOMEBASE_FEATURE_FLAG);
}

/**
 * Class Record replaces the section Learners tab, except for 1:1 classes and
 * clubs, whose Learners pages have tools the Class Record doesn't.
 */
export function useClassRecordReplacesLearnersTab(
  activity: { isClub: boolean; hasTeacherSchedule: boolean } | null | undefined,
) {
  const isLmsTeacherHomebase = useLmsTeacherHomebase();
  return (
    isLmsTeacherHomebase &&
    !!activity &&
    !activity.isClub &&
    !activity.hasTeacherSchedule
  );
}
